import { Mail, ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useState } from 'react';

export function IntegrityNewsletter() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const trimmed = email.trim();
    if (!trimmed) { setError('Please enter your email address.'); return; }
    if (trimmed.length > 255) { setError('Email must be less than 255 characters.'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) { setError('Please enter a valid email address.'); return; }
    setSubmitted(true);
  };

  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="max-w-2xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg border border-primary/20 bg-primary/5 mb-6">
          <Mail className="h-5 w-5 text-primary" strokeWidth={1.5} />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-3">
          The Integrity Newsletter
        </h2>
        <p className="text-lg font-medium text-foreground mb-2">Stay ahead of payer logic.</p>
        <p className="text-muted-foreground leading-relaxed mb-8 max-w-lg mx-auto">
          Join 500+ Hospital CFOs and Surgery Chiefs receiving Dr.&nbsp;Larkin's
          monthly briefing on Revenue Integrity.
        </p>

        {!submitted ? (
          <form onSubmit={handleSubmit} className="space-y-3">
            <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your work email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); if (error) setError(''); }}
                maxLength={255}
                className="flex-1 h-12 rounded-md border border-border bg-card px-4 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-cta/30 focus:border-cta/40 transition-colors"
              />
              <Button
                type="submit"
                size="lg"
                className="bg-cta hover:bg-cta/90 text-cta-foreground font-bold px-6 rounded-md h-12 whitespace-nowrap"
              >
                Join the Briefing
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>
            {error && <p className="text-xs text-destructive font-medium">{error}</p>}
            <p className="text-xs text-muted-foreground">Monthly. No spam. Unsubscribe anytime.</p>
          </form>
        ) : (
          <div className="rounded-xl border border-primary/30 bg-primary/5 p-6 max-w-md mx-auto space-y-2">
            <p className="text-sm font-semibold text-primary flex items-center justify-center gap-2">
              <CheckCircle className="h-4 w-4" /> You're on the list
            </p>
            <p className="text-xs text-muted-foreground">Watch for Dr.&nbsp;Larkin's next briefing in your inbox.</p>
          </div>
        )}
      </div>
    </section>
  );
}
